import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const useFetchUserAssets = (userId, showAddModal) => {
    const [assets, setAssets] = useState([]);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchAssets = async () => {
        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });

            const response = await fetch(`${apiUrl}/api/assets/user/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();
            setAssets(data);
            console.log(data);
        } catch (error) {
            console.error('Error fetching assets:', error);
        }
    };

    useEffect(() => {
        fetchAssets();
    }, [userId, showAddModal]);

    return assets;
};

export default useFetchUserAssets;
